import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class ImageService {
  constructor(private http: HttpClient) {}

  downloadImage(path: string, onLoadend: (base64data: string) => void) {
    this.http.get(path, { responseType: 'blob' }).subscribe((res: Blob) => {
      const inferredMime = res.type.startsWith('image/') ? res.type : 'image/png';

      const reader = new FileReader();
      reader.onloadend = () => {
        let base64 = reader.result as string;

        if (!base64.startsWith(`data:image`)) {
          const rawBase64 = base64.split(',')[1];
          base64 = `data:${inferredMime};base64,${rawBase64}`;
        }

        onLoadend(base64);
      };
      reader.readAsDataURL(res);
    });
  }

}
